import sha256 from 'crypto-js/sha256';

const hashUserData = (hashString: string, hashSecurityKey: string): string =>
  sha256(hashString + hashSecurityKey).toString();

export default hashUserData;
